/* eslint-disable */
const pageEvent = document.querySelector('body.tribe_events-template-default');

if (pageEvent) {

  const venue = document.querySelector('.venue');

  console.log(venue.dataset.lat, venue.dataset.long);
  mapboxgl.accessToken = 'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2tlMmhob3hkMDlibzMxbjcwM2x2bWRnbiJ9.epIHoVvz_0DGDq39sSzZiA';
  var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
  center: [venue.dataset.long, venue.dataset.lat], // starting position [lng, lat]
  zoom: 13 // starting zoom
  });
}



// WEBPACK FOOTER //
// ./scripts/map.js